export const contentAllowedSSLA = {
  1: 'Solo para todas las edades',
  2: 'Hasta 7 años',
  3: 'Hasta 10 años',
  4: 'Hasta 13 años',
  5: 'Hasta 14 años',
  6: 'Hasta 17 años',
  7: 'Todos los contenidos',
};
